function ytCmd(iframe, func) {
  iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func, args: [] }), '*');
}

function toggleSlideVideo(slideEl, play) {
  const iframes = slideEl.querySelectorAll('iframe');
  if (!iframes.length) return;

  iframes.forEach((ifr) => {;
    ytCmd(ifr, 'mute');
    ytCmd(ifr, play ? 'playVideo' : 'pauseVideo');
  });
}


export function controlActive(swiper) {
  swiper.slides.forEach((slide, idx) => {
    toggleSlideVideo(slide, idx === swiper.activeIndex);
  });
}